import { useNavigate } from "react-router-dom";
import "./RefundShared.css";

const Refund2 = () => {
    const navigate = useNavigate();

    const relatedArticles = [
        {
            title: "What is your refund policy?",
            description: "Learn about our refund policy and how to request a refund for your purchase.",
            link: "/what-is-your-refund-policy?"
        },
        {
            title: "How long does it take to process a refund?",
            description: "Understand the timeline for refund processing and when to expect your money back.",
            link: "/how-long-does-it-take-to-process-a-refund?"
        }
    ];

    return (
        <div className="rf-container">
            <header className="rf-header">
                <div className="rf-container-1200">
                    {/* <div className="rf-header-content">
                        <button 
                            className="rf-back-btn"
                            onClick={() => navigate(-1)}
                        >
                            <FaArrowLeft /> Back
                        </button>
                        <div className="rf-logo">
                            <a href="/">BooksComply</a>
                        </div>
                        <div className="rf-top-bar">
                            <a href="/submitrequest" className="rf-submit-btn">
                                <FaQuestionCircle className="btn-icon" /> Submit a request
                            </a>
                        </div>
                    </div> */}
                </div>
            </header>
            
            <main className="rf-main-content">
                <div className="rf-container-1200">
                    <nav className="rf-breadcrumb">
                        <ol>
                            <li><a href="/help">Help Center</a></li>
                            <li><a href="/refund">Refund and Pricing</a></li>
                            <li>Payment Methods</li>
                        </ol>
                    </nav>

                    <article className="rf-article">
                        <header className="rf-article-header">
                            <h1 className="rf-article-title">What payment methods do you accept?</h1>
                            <div className="rf-article-meta">
                                <span>Posted by BooksComply Team</span>
                                <span>•</span>
                                <span>Last updated August 2025</span>
                            </div>
                        </header>
                        
                        <div className="rf-article-content">
                            <p>
                                We accept payments in Indian currency via QR Code, Debit Card, Credit Card, and Net Banking. For international transactions, credit card payments are accepted.
                            </p>
                            
                            {/* <h3>Available Payment Options</h3>
                            <div className="rf-payment-methods">
                                {paymentMethods.map((method, index) => (
                                    <div key={index} className="rf-payment-method">
                                        <div className="rf-payment-icon-container">
                                            {method.icon}
                                        </div>
                                        <div className="rf-payment-details">
                                            <h4>{method.title}</h4>
                                            <p>{method.description}</p>
                                            {method.supported && (
                                                <div className="rf-supported-brands">
                                                    <span>Supported: </span>
                                                    {method.supported.join(", ")}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div> */}
                            
                            {/* <div className="rf-note">
                                <h4>Important Note:</h4>
                                <ul>
                                    <li>All transactions are secured with 128-bit SSL encryption</li>
                                    <li>We do not store your payment details on our servers</li>
                                    <li>International transactions may be subject to currency conversion fees</li>
                                </ul>
                            </div> */}
                        </div>
                    </article>
                    
                    {/* <div className="rf-helpful-section">
                        <h3 className="rf-helpful-title">Was this article helpful?</h3>
                        <div className="rf-helpful-buttons">
                            <button className="rf-helpful-btn positive">
                                <FaCheckCircle /> Yes, it was helpful
                            </button>
                            <button className="rf-helpful-btn negative">
                                <FaTimesCircle /> No, I need more help
                            </button>
                        </div>
                    </div> */}
                    
                    <div className="rf-related-articles">
                        <h2 className="rf-related-title">Related Articles</h2>
                        <div className="rf-related-grid">
                            {relatedArticles.map((article, index) => (
                                <a 
                                    key={index} 
                                    href={article.link} 
                                    className="rf-related-card"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate(article.link);
                                    }}
                                >
                                    <h3>{article.title}</h3>
                                    <p>{article.description}</p>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Refund2;